import React, { useCallback, useEffect, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function IssueCarousel({ items, renderItem, dark = false, testid = 'issue-carousel', slide = 'basis-[46%] sm:basis-[31%] lg:basis-[18%]' }) {
  const [emblaRef, embla] = useEmblaCarousel({ align: 'start', dragFree: true, containScroll: 'trimSnaps' });
  const [can, setCan] = useState({ prev: false, next: false });
  const update = useCallback(() => embla && setCan({ prev: embla.canScrollPrev(), next: embla.canScrollNext() }), [embla]);
  useEffect(() => {
    if (!embla) return undefined;
    update();
    embla.on('select', update).on('reInit', update).on('scroll', update);
    return () => { embla.off('select', update).off('reInit', update).off('scroll', update); };
  }, [embla, update]);
  const btn = `w-11 h-11 rounded-full flex items-center justify-center transition-colors disabled:opacity-30 ${dark ? 'bg-white/10 text-white hover:bg-[#D01919]' : 'bg-[#111111] text-white hover:bg-[#D01919]'}`;
  return (
    <div data-testid={testid}>
      <div className="overflow-hidden cursor-grab active:cursor-grabbing" ref={emblaRef}>
        <div className="flex -ml-5 touch-pan-y">
          {items.map((it, i) => <div key={it.id || i} className={`shrink-0 pl-5 ${slide}`}>{renderItem(it, i)}</div>)}
        </div>
      </div>
      <div className="flex items-center gap-3 mt-6">
        <button className={btn} disabled={!can.prev} onClick={() => embla?.scrollPrev()} data-testid={`${testid}-prev`} aria-label="Previous issues"><ChevronLeft size={20} /></button>
        <button className={btn} disabled={!can.next} onClick={() => embla?.scrollNext()} data-testid={`${testid}-next`} aria-label="More issues"><ChevronRight size={20} /></button>
        <span className={`text-sm ml-2 ${dark ? 'text-white/50' : 'text-[#999999]'}`}>Drag or use the arrows to browse {items.length} issues</span>
      </div>
    </div>
  );
}
